import { UserRoles, ExternalSpec, ArmadorType } from '../../managers/identity/RoleCapacitiesManager'

export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  roles?: Array<UserRoles | ExternalSpec | ArmadorType> // Si el dato es un externalSpec se asume que es UserRoles.EXTERNO Y si es un ArmadorType se asume que es UserRoles.EXTERNO y ExternalSpec.ARMADOR
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Inicio',
      meta: {
        icon: 'home',
      },
    },
    {
      displayName: 'Inscripción',
      name: 'enrollment',
      meta: {
        icon: 'fact_check',
      },
      children: [
        /*{
          name: 'enrollment-armadores',
          displayName: 'Armadores',
          roles: [UserRoles.ADMIN , ExternalSpec.ARMADOR],
        },*/
        {
          name: 'enrollment-embarcaciones',
          displayName: 'Embarcaciones',
          roles: [ExternalSpec.ARMADOR],
        },
        {
          name: 'enrollment-tripulantes',
          displayName: 'Tripulantes',
          roles: [ExternalSpec.ARMADOR],
        },
        /*
        {
          name: 'mis-representantes',
          displayName: 'Apoderados',
          roles: [ArmadorType.DIRECTO],
        },
        */
        /*{
          name: 'enrollment-proveedores',
          displayName: 'Proveedores',
          roles: [UserRoles.ADMIN],
        },*/
      ],
    },
    {
      displayName: 'Revisión inscripción',
      name: 'enrollment-check',
      meta: {
        icon: 'flaky',
      },
      children: [
        {
          name: 'enrollment-armadores-check',
          displayName: 'Armadores',
          roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR],
        },
        {
          name: 'enrollment-embarcaciones-check',
          displayName: 'Embarcaciones',
          roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR],
        },
        {
          name: 'enrollment-tripulantes-check',
          displayName: 'Tripulantes',
          roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR],
        },
        {
          name: 'enrollment-proveedores-check',
          displayName: 'Proveedores',
          roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR],
        },
        /*
        {
          name: 'enrollment-representantes-check',
          displayName: 'Apoderados',
          roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR],
        },
        */
        {
          name: 'administration-otros',
          displayName: 'Otros usuarios',
          roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, UserRoles.OPERADOR],
        },
        {
          name: 'enrollment-esporadicos-check',
          displayName: 'Esporádicos',
          roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, UserRoles.OPERADOR],
        },
      ],
    },
    {
      displayName: 'Administración',
      name: 'administracion',
      meta: {
        icon: 'manage_accounts',
      },
      children: [
        {
          name: 'administration-users',
          displayName: 'Usuarios',
          roles: [UserRoles.ADMIN],
        },
        {
          name: 'administration-tarifas',
          displayName: 'Tarifas',
          roles: [UserRoles.ADMIN],
        },
        {
          name: 'administration-horarios',
          displayName: 'Horarios',
          roles: [UserRoles.ADMIN],
        },
        {
          name: 'administration-roles-alternativos',
          displayName: 'Roles Alternativos',
          roles: [UserRoles.ADMIN],
        },
        {
          name: 'administration-configuracion-credenciales',
          displayName: 'Config. Credenciales',
          roles: [UserRoles.ADMIN],
        },
        {
          name: 'administration-configuracion',
          displayName: 'Configuración',
          roles: [UserRoles.ADMIN],
        },
      ],
    },
    {
      name: 'services',
      displayName: 'Servicios MW',
      meta: {
        icon: 'build',
      },
      roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, UserRoles.OPERADOR, UserRoles.EXTERNO],
    },
    {
      name: 'preacreditacion',
      displayName: 'Pre-acreditación',
      meta: {
        icon: 'badge',
      },
      roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, UserRoles.OPERADOR],
    },
    {
      name: 'finanzas-check',
      displayName: 'Facturación',
      meta: {
        icon: 'paid',
      },
      roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, ExternalSpec.ARMADOR],
    },
    {
      name: 'control',
      displayName: 'Control MP',
      meta: {
        icon: 'menu_book',
      },
      roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, UserRoles.OPERADOR],
    },
    {
      name: 'reportes',
      displayName: 'Reportes',
      meta: {
        icon: 'insert_drive_file',
      },
      roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, UserRoles.GESTOR],
    },
    {
      name: 'reportes-armador',
      displayName: 'Reportes Armador',
      meta: {
        icon: 'insert_drive_file',
      },
      roles: [ExternalSpec.ARMADOR],
    },
    {
      name: 'auditoria',
      displayName: 'Auditoria',
      meta: {
        icon: 'assessment',
      },
      roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, UserRoles.GESTOR],
    },
    {
      name: 'marcas',
      displayName: 'Marcas torniquete',
      meta: {
        icon: 'fingerprint',
      },
      roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, UserRoles.GESTOR, UserRoles.OPERADOR],
    },
    {
      name: 'autorizacion-zarpe',
      displayName: 'Autorización de zarpe',
      meta: {
        icon: 'directions_boat',
      },
      roles: [UserRoles.ADMIN, UserRoles.SUPERVISOR, UserRoles.OPERADOR, ExternalSpec.ARMADOR],
    },
    {
      name: 'viajes-backup',
      displayName: 'Solicitar viajes (Respaldado)',
      meta: {
        icon: 'badge',
      },
      roles: [UserRoles.ADMIN],
    },
    {
      name: 'preferences',
      displayName: 'Mi información',
      meta: {
        icon: 'fact_check',
      },
      roles: [ExternalSpec.PROVEEDOR, UserRoles.REPRESENTANTE],
    },
  ] as INavigationRoute[],
}
